<template>
  <el-dialog
    :title="$t('pricedialog.require')"
    :visible.sync="$store.state.otherDialogStatus"
    width="48%"
    @close='closeDialog'
    center
  >
    <!-- 其他需求  -->
    <el-form
      :label-width="this.$i18n.locale=='en'?'160px':'120px'"
      :model="requestForm"
      ref="requestForm"
      :rules="requestrules"
    >
      <el-form-item
        :label="$t('pricedialog.theme')"
        prop="theme"
      >
        <el-input
          v-model="requestForm.theme"
          :placeholder="$t('checkvalid.theme')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('pricedialog.contacts')" prop="contacts">
        <el-input
          v-model="requestForm.contacts"
          :placeholder="$t('checkvalid.contacts')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('pricedialog.phone')"
        prop="phone"
      >
        <el-input
          v-model="requestForm.phone"
          :placeholder="$t('checkvalid.contactsphone')"
        ></el-input>
      </el-form-item>
      <el-form-item
         :label="$t('pricedialog.remarks')"
        prop="remarks"
      >
        <div class="remarks">
          <quill-editor
            v-model="requestForm.remarks"
            ref="myQuillEditor"
            class="editer"
            :options="editorOption"
            @change="onEditorReady($event)"
          ></quill-editor>
        </div>

      </el-form-item>
      <el-form-item>
        <p style="font-size:12px;color:#999;">{{$t('pricedialog.radiobtn')}}</p>
        <el-button
          @click="submitrequest('requestForm')"
          type="success"
        >{{$t('pricedialog.btn')}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import "../../../node_modules/quill/dist/quill.core.css";
import "../../../node_modules/quill/dist/quill.snow.css";
import "../../../node_modules/quill/dist/quill.bubble.css";
export default {
  components: {
    //使用编辑器
    quillEditor
  },
  data() {
    var phonevalid = (rule, value, callback) => {
        var rest = /^[1][3,4,5,7,8][0-9]{9}$/;
        if (!rest.test(value)) {
          return callback(new Error(this.$t('checkvalid.phone')));
        } else {
           callback();
        }
    };
    return {
      requestForm: {
        theme: "",
        contacts: "",
        phone: "",
        remarks: ""
      },
      content: "",
      requestrules: {
        theme: [{ required: true, message: this.$t('checkvalid.theme'), trigger: "blur" }],
        phone: [{ required: true, validator: phonevalid, trigger: "blur" }],
        remarks: [
          { required: true, message: this.$t('checkvalid.remarks'), trigger: "blur" }
        ],
        contacts:[{required: true, message: this.$t('checkvalid.contacts'), trigger: "blur"}]
      },
      editorOption: {
        placeholder: this.$t('checkvalid.text')
      }
    };
  },
  created() {},
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  methods: {
    onEditorReady({ editor, html, text }) {
      this.requestForm.remarks = html;
      console.log(this.requestForm.remarks);
    },
    closeDialog() {
      this.$refs.requestForm.resetFields();
      this.$store.state.otherDialogStatus = false;
    },
    submitrequest(requestForm) {
      this.$refs.requestForm.validate(valid => {
        if (valid) {
          const data = {
            token: this.$store.state.token,
            title: this.requestForm.theme,
            contact_phone: this.requestForm.phone,
            contact: this.requestForm.contacts,
            content: this.requestForm.remarks
          };
          this.$http
            .post("/price/other_demand", data)
            .then(res => {
              console.log(res);
              if (res.status == 200) {
                if (res.data.status == 0) {
                  this.$message({
                    message: this.$t('checkvalid.require'),
                    type: "success",
                    duration: 1500
                  });
                  this.$store.state.otherDialogStatus = false;
                } else {
                  this.$message({
                    message: res.data.error,
                    type: "warning",
                    duration: 1500
                  });
                  return;
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.required {
  .remarks {
  }
}
</style>


